import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { Warehouse as T } from 'models';
import { getQueryParams } from 'utils';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/warehouses`;
const tagType = TAG_TYPES.Warehouse;

const WarehouseApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllWarehouses: builder.query<
      {
        data: {
          rows: T[];
          count: number;
        };
        success: boolean;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        if (query === '') return { url: urlEndpoint, method: 'GET' };
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data.rows || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),

    getWarehouseById: builder.query<{ data: T }, string>({
      query: (id) => ({
        url: `${urlEndpoint}/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: tagType, id }],
    }),

    activeWarehouse: builder.mutation<{ data: T; success: boolean }, string>({
      query: (id) => ({
        url: `${urlEndpoint}/${id}/active`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: tagType, id: 'LIST' }],
    }),
  }),
});

export const {
  useGetAllWarehousesQuery,
  useGetWarehouseByIdQuery,
  useLazyGetWarehouseByIdQuery,
  useActiveWarehouseMutation,
} = WarehouseApiService;
